if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.url) {
        this.performRecommendations();
      } else {
        this.initSlider();
        this.initQuickAdd();
      }
    }

    performRecommendations() {
      const recommendations = this.querySelector('[data-recommendations]');
      if (!recommendations) return;

      fetch(this.dataset.url)
        .then(r => r.text())
        .then(text => {
          const html = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!html) return;

          this.classList.remove('hidden');
          recommendations.innerHTML = html;
          this.initSlider();
          this.initQuickAdd();
        });
    }

    initSlider() {
      const swiperEl = this.querySelector('.swiper');
      const prevBtn = this.querySelector('.rec-nav-prev');
      const nextBtn = this.querySelector('.rec-nav-next');

      if (!swiperEl) return;

      this.slider = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        watchOverflow: true,
        ...(prevBtn && nextBtn ? {
          navigation: { prevEl: prevBtn, nextEl: nextBtn }
        } : {}),
        on: {
          init: s => this.updateNav(s, prevBtn, nextBtn),
          slideChange: s => this.updateNav(s, prevBtn, nextBtn),
        }
      });
    }

    updateNav(swiper, prev, next) {
      if (!prev || !next) return;
      prev.disabled = swiper.isBeginning;
      next.disabled = swiper.isEnd;
      const nav = prev.closest('.rec-nav');
      if (nav) nav.style.visibility = swiper.isBeginning && swiper.isEnd ? 'hidden' : 'visible';
    }

    initQuickAdd() {
      this.querySelectorAll('.rec-quick-add').forEach(btn => {
        btn.addEventListener('click', () => this.handleQuickAdd(btn));
      });
    }

    handleQuickAdd(btn) {
      if (btn.dataset.available === 'false' || btn.disabled) return;

      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch(routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          id: btn.dataset.variantId,
          quantity: 1,
          sections: sectionsToRender.map(s => s.section),
          sections_url: window.location.pathname,
        }),
      })
        .then(r => { if (!r.ok) throw new Error(); return r.json(); })
        .then(response => {
          sectionsToRender.forEach(section => {
            const el = document.querySelector(section.id);
            if (!el) return;
            el.innerHTML = new DOMParser()
              .parseFromString(response.sections[section.section], 'text/html')
              .querySelector(section.selector)?.innerHTML || '';
          });

          updateCartCounters();
          updateFreeShipping();

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && !cartDrawer.classList.contains('is-visible')) cartDrawer.open();

          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(() => { btn.classList.remove('is-added'); btn.disabled = false; }, 2000);
        })
        .catch(() => {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          setTimeout(() => { btn.classList.remove('is-error'); btn.disabled = false; }, 2000);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}